import { AcceptTermsLabel } from "@circle-react/components/OnboardingPage/CreateProfilePage/AcceptTermsLabel";
import { Checkbox } from "@circle-react-uikit/Form/Checkbox";

const termsOfServiceKey = "termsOfService" as const;

export const CheckoutFormTOS = () => (
  <div className="flex">
    <div className="inline-flex items-start gap-3">
      <Checkbox
        id="terms"
        name={termsOfServiceKey}
        label={<AcceptTermsLabel variant="paywallCheckout" />}
      />
    </div>
  </div>
);
